import { createSlice } from '@reduxjs/toolkit'

// Mapping of IANA time zones to human-readable names
export const TIMEZONE_NAMES = {
  'America/New_York': 'Eastern Time',
  'America/Chicago': 'Central Time',
  'America/Denver': 'Mountain Time',
  'America/Los_Angeles': 'Pacific Time',
  'America/Anchorage': 'Alaska Time',
  'Pacific/Honolulu': 'Hawaii Time',
  'Asia/Karachi': 'Pakistan Time',
  'Asia/Tokyo': 'Japan Time',
  'Asia/Shanghai': 'China Time',
  'Asia/Dubai': 'Gulf Time',
  'Europe/London': 'British Time',
  'Europe/Paris': 'Central European Time',
  'Europe/Moscow': 'Moscow Time',
  'Australia/Sydney': 'Australian Eastern Time',
  'Pacific/Auckland': 'New Zealand Time'
}

const timeZoneSlice = createSlice({
  name: 'timeZone',
  initialState: {
    userTimeZone: null, // IANA Timezone
    userTimeZoneName: null, // Human-readable name
  },
  reducers: {
    setUserTimeZone: (state, action) => {
      state.userTimeZone = action.payload
      state.userTimeZoneName =
        TIMEZONE_NAMES[action.payload] || 'Unknown Time Zone'
    },
    resetTimeZone: (state) => {
      state.userTimeZone = null
      state.userTimeZoneName = null
    },
  },
})

export const { setUserTimeZone, resetTimeZone } = timeZoneSlice.actions

export default timeZoneSlice.reducer
